// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Caml_js_exceptions from "rescript/lib/es6/caml_js_exceptions.js";
import * as Utils$OrcaPaymentPage from "./Utils.bs.js";
import * as Window$OrcaPaymentPage from "../Window.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as PaymentBody$OrcaPaymentPage from "./PaymentBody.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./PaymentUtils.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";
import * as ApplePayTypes$OrcaPaymentPage from "../Types/ApplePayTypes.bs.js";
import * as TaxCalculation$OrcaPaymentPage from "./TaxCalculation.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "./DynamicFieldsUtils.bs.js";
import * as PaymentMethodsRecord$OrcaPaymentPage from "../Payments/PaymentMethodsRecord.bs.js";

function processPayment(bodyArr, isThirdPartyFlowOpt, isGuestCustomer, paymentMethodListValueOpt, intent, options, publishableKey, isManualRetryEnabled) {
  var isThirdPartyFlow = isThirdPartyFlowOpt !== undefined ? isThirdPartyFlowOpt : false;
  var paymentMethodListValue = paymentMethodListValueOpt !== undefined ? paymentMethodListValueOpt : PaymentMethodsRecord$OrcaPaymentPage.defaultList;
  var requestBody = PaymentUtils$OrcaPaymentPage.appendedCustomerAcceptance(isGuestCustomer, paymentMethodListValue.payment_type, bodyArr);
  intent(true, requestBody, {
        return_url: options.wallets.walletReturnUrl,
        publishableKey: publishableKey
      }, undefined, isThirdPartyFlow, undefined, isManualRetryEnabled);
}

function getApplePayFromResponse(token, billingContactDict, shippingContactDict, requiredFieldsOpt, connectors, isPaymentSessionOpt, isSavedMethodsFlowOpt) {
  var requiredFields = requiredFieldsOpt !== undefined ? requiredFieldsOpt : [];
  var isPaymentSession = isPaymentSessionOpt !== undefined ? isPaymentSessionOpt : false;
  var isSavedMethodsFlow = isSavedMethodsFlowOpt !== undefined ? isSavedMethodsFlowOpt : false;
  var billingContact = ApplePayTypes$OrcaPaymentPage.billingContactItemToObjMapper(billingContactDict);
  var shippingContact = ApplePayTypes$OrcaPaymentPage.shippingContactItemToObjMapper(shippingContactDict);
  var requiredFieldsBody = isPaymentSession || isSavedMethodsFlow ? DynamicFieldsUtils$OrcaPaymentPage.getApplePayRequiredFields(billingContact, shippingContact, undefined) : DynamicFieldsUtils$OrcaPaymentPage.getApplePayRequiredFields(billingContact, shippingContact, requiredFields);
  var bodyDict = PaymentBody$OrcaPaymentPage.applePayBody(token, connectors);
  return Utils$OrcaPaymentPage.mergeAndFlattenToTuples(bodyDict, requiredFieldsBody);
}

function startApplePaySession(paymentRequest, applePaySessionRef, applePayPresent, logger, callBackFunc, resolvePromise, clientSecret, publishableKey, isTaxCalculationEnabledOpt, sdkAuthorizationOpt) {
  var isTaxCalculationEnabled = isTaxCalculationEnabledOpt !== undefined ? isTaxCalculationEnabledOpt : false;
  var sdkAuthorization = sdkAuthorizationOpt !== undefined ? Caml_option.valFromOption(sdkAuthorizationOpt) : undefined;
  var ssn = new ApplePaySession(14, paymentRequest);
  var session = applePaySessionRef.contents;
  if (!(session == null)) {
    try {
      session.abort();
    }
    catch (raw_error){
      var error = Caml_js_exceptions.internalToOCamlException(raw_error);
      console.error("Abort fail", error);
    }
  }
  applePaySessionRef.contents = ssn;
  ssn.onvalidatemerchant = (function (_event) {
      var merchantSession = Utils$OrcaPaymentPage.transformKeys(Core__Option.getOr(Core__Option.getOr(Belt_Option.flatMap(applePayPresent, Core__JSON.Decode.object), {})["session_token_data"], {}), "CamelCase");
      ssn.completeMerchantValidation(merchantSession);
    });
  ssn.onshippingcontactselected = (function (shippingAddressChangeEvent) {
      var currentTotal = Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromJson(paymentRequest), "total");
      var label = Utils$OrcaPaymentPage.getString(currentTotal, "label", "apple");
      var currentAmount = Utils$OrcaPaymentPage.getString(currentTotal, "amount", "0.00");
      var type = Utils$OrcaPaymentPage.getString(currentTotal, "type", "final");
      var oldTotal = {
        label: label,
        amount: currentAmount,
        type: type
      };
      var currentOrderDetails_newLineItems = [oldTotal];
      var currentOrderDetails = {
        newTotal: oldTotal,
        newLineItems: currentOrderDetails_newLineItems
      };
      if (isTaxCalculationEnabled) {
        var newShippingContact = ApplePayTypes$OrcaPaymentPage.shippingContactItemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(shippingAddressChangeEvent.shippingContact));
        var newShippingAddress = Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
              [
                "state",
                newShippingContact.administrativeArea
              ],
              [
                "country",
                newShippingContact.countryCode
              ],
              [
                "zip",
                newShippingContact.postalCode
              ]
            ]);
        return TaxCalculation$OrcaPaymentPage.calculateTax(Utils$OrcaPaymentPage.getJsonFromArrayOfJson([[
                            "address",
                            newShippingAddress
                          ]]), logger, clientSecret, publishableKey, "apple_pay", undefined, Caml_option.some(sdkAuthorization)).then(function (response) {
                    var taxCalculationResponse = TaxCalculation$OrcaPaymentPage.taxResponseToObjMapper(response);
                    if (taxCalculationResponse === undefined) {
                      return ssn.completeShippingContactSelection(currentOrderDetails);
                    }
                    var netAmount = taxCalculationResponse.net_amount;
                    var ordertaxAmount = taxCalculationResponse.order_tax_amount;
                    var shippingCost = taxCalculationResponse.shipping_cost;
                    var newTotal_amount = Utils$OrcaPaymentPage.minorUnitToString(netAmount);
                    var newTotal = {
                      label: label,
                      amount: newTotal_amount,
                      type: type
                    };
                    var newLineItems = [
                      {
                        label: "Subtotal",
                        amount: Utils$OrcaPaymentPage.minorUnitToString((netAmount - ordertaxAmount | 0) - shippingCost | 0),
                        type: "final"
                      },
                      {
                        label: "Order Tax Amount",
                        amount: Utils$OrcaPaymentPage.minorUnitToString(ordertaxAmount),
                        type: "final"
                      },
                      {
                        label: "Shipping Cost",
                        amount: Utils$OrcaPaymentPage.minorUnitToString(shippingCost),
                        type: "final"
                      }
                    ];
                    var updatedOrderDetails = {
                      newTotal: newTotal,
                      newLineItems: newLineItems
                    };
                    ssn.completeShippingContactSelection(updatedOrderDetails);
                  });
      }
      ssn.completeShippingContactSelection(currentOrderDetails);
      return Promise.resolve();
    });
  ssn.onpaymentauthorized = (function ($$event) {
      ssn.completePayment({
            status: ssn.STATUS_SUCCESS
          });
      applePaySessionRef.contents = null;
      logger.setLogInfo("Payment Data Filled: New Payment Method", "PAYMENT_DATA_FILLED", undefined, undefined, undefined, undefined, "APPLE_PAY");
      var payment = $$event.payment;
      callBackFunc(payment);
    });
  ssn.oncancel = (function () {
      applePaySessionRef.contents = null;
      logger.setLogError("Apple Pay Payment Cancelled", "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
      resolvePromise(Utils$OrcaPaymentPage.handleFailureResponse("ApplePay Session Cancelled", "apple_pay"));
    });
  ssn.begin();
}

function useHandleApplePayResponse(connectors, intent, setApplePayClickedOpt, syncPaymentOpt, isInvokeSDKFlowOpt, isSavedMethodsFlowOpt, isWalletOpt, requiredFieldsBodyOpt, sdkAuthorization) {
  var setApplePayClicked = setApplePayClickedOpt !== undefined ? setApplePayClickedOpt : (function (param) {
        
      });
  var syncPayment = syncPaymentOpt !== undefined ? syncPaymentOpt : (function () {
        
      });
  var isInvokeSDKFlow = isInvokeSDKFlowOpt !== undefined ? isInvokeSDKFlowOpt : true;
  var isSavedMethodsFlow = isSavedMethodsFlowOpt !== undefined ? isSavedMethodsFlowOpt : false;
  var isWallet = isWalletOpt !== undefined ? isWalletOpt : true;
  var requiredFieldsBody = requiredFieldsBodyOpt !== undefined ? requiredFieldsBodyOpt : ({});
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.keys);
  var publishableKey = match.publishableKey;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var logger = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var isGuestCustomer = UtilityHooks$OrcaPaymentPage.useIsGuestCustomer();
  var paymentMethodTypes = DynamicFieldsUtils$OrcaPaymentPage.usePaymentMethodTypeFromList(paymentMethodListValue, "wallet", "apple_pay");
  var isManualRetryEnabled = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.isManualRetryEnabled);
  React.useEffect((function () {
          var handleApplePayMessages = function (ev) {
            var json = Utils$OrcaPaymentPage.safeParse(ev.data);
            try {
              var dict = Utils$OrcaPaymentPage.getDictFromJson(json);
              if (Core__Option.isSome(dict["applePayPaymentToken"]) && Utils$OrcaPaymentPage.getBool(dict, "isSavedMethodsFlow", false) === isSavedMethodsFlow) {
                var token = Core__Option.getOr(dict["applePayPaymentToken"], {});
                var billingContactDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "applePayBillingContact");
                var shippingContactDict = Utils$OrcaPaymentPage.getDictFromDict(dict, "applePayShippingContact");
                var applePayBody = getApplePayFromResponse(token, billingContactDict, shippingContactDict, paymentMethodTypes.required_fields, connectors, undefined, isSavedMethodsFlow);
                var bodyArr = isWallet ? applePayBody : Utils$OrcaPaymentPage.mergeAndFlattenToTuples(applePayBody, requiredFieldsBody);
                return processPayment(bodyArr, false, isGuestCustomer, paymentMethodListValue, intent, options, publishableKey, isManualRetryEnabled);
              }
              if (Core__Option.isSome(dict["showApplePayButton"])) {
                setApplePayClicked(function (param) {
                      return false;
                    });
                if (isSavedMethodsFlow || !isWallet) {
                  return Utils$OrcaPaymentPage.postFailedSubmitResponse("server_error", "Something went wrong");
                } else {
                  return ;
                }
              }
              if (Core__Option.isSome(dict["applePaySyncPayment"])) {
                return syncPayment();
              }
              if (!Core__Option.isSome(dict["applePayBraintreeSuccess"])) {
                return ;
              }
              var token$1 = Utils$OrcaPaymentPage.getString(dict, "token", "");
              return processPayment(PaymentBody$OrcaPaymentPage.applePayThirdPartySdkBody(connectors, token$1), true, isGuestCustomer, paymentMethodListValue, intent, options, publishableKey, isManualRetryEnabled);
            }
            catch (exn){
              return logger.setLogError("Error in parsing Apple Pay Data", "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
            }
          };
          window.addEventListener("message", handleApplePayMessages);
          return (function () {
                    Utils$OrcaPaymentPage.messageParentWindow(undefined, [[
                            "applePaySessionAbort",
                            true
                          ]]);
                    window.removeEventListener("message", handleApplePayMessages);
                  });
        }), [
        isInvokeSDKFlow,
        processPayment,
        isManualRetryEnabled,
        isWallet,
        requiredFieldsBody,
        isSavedMethodsFlow,
        sdkAuthorization
      ]);
}

function handleApplePayButtonClicked(sessionObj, componentName, paymentMethodListValue, isSavedMethodsFlowOpt) {
  var isSavedMethodsFlow = isSavedMethodsFlowOpt !== undefined ? isSavedMethodsFlowOpt : false;
  var paymentRequest = ApplePayTypes$OrcaPaymentPage.getPaymentRequestFromSession(sessionObj, componentName);
  var authToken = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getDictFromDict(Utils$OrcaPaymentPage.getOptionsDict(sessionObj), "session_token_data"), "secrets"), "display", "");
  var connector = Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getOptionsDict(sessionObj), "connector", "");
  var message = [
    [
      "applePayButtonClicked",
      true
    ],
    [
      "applePayPaymentRequest",
      paymentRequest
    ],
    [
      "isTaxCalculationEnabled",
      paymentMethodListValue.is_tax_calculation_enabled
    ],
    [
      "componentName",
      componentName
    ],
    [
      "authToken",
      authToken
    ],
    [
      "connector",
      connector
    ],
    [
      "isSavedMethodsFlow",
      isSavedMethodsFlow
    ]
  ];
  Utils$OrcaPaymentPage.messageParentWindow(undefined, message);
}

function useSubmitCallback(isWallet, sessionObj, componentName) {
  var areRequiredFieldsValid = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areRequiredFieldsValid);
  var areRequiredFieldsEmpty = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.areRequiredFieldsEmpty);
  var options = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  return React.useCallback((function (ev) {
                if (isWallet) {
                  return ;
                }
                var json = Utils$OrcaPaymentPage.safeParse(ev.data);
                var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
                if (confirm.doSubmit && areRequiredFieldsValid && !areRequiredFieldsEmpty) {
                  if (!options.readOnly) {
                    return handleApplePayButtonClicked(sessionObj, componentName, paymentMethodListValue, undefined);
                  } else {
                    return ;
                  }
                } else if (areRequiredFieldsEmpty) {
                  return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterFieldsText);
                } else if (!areRequiredFieldsValid) {
                  return Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", localeString.enterValidDetailsText);
                } else {
                  return ;
                }
              }), [
              areRequiredFieldsValid,
              areRequiredFieldsEmpty,
              isWallet,
              sessionObj,
              componentName
            ]);
}

function createApplePayTransactionInfo(jsonDict) {
  return {
          countryCode: Utils$OrcaPaymentPage.getString(jsonDict, "countryCode", Utils$OrcaPaymentPage.defaultCountryCode),
          currencyCode: Utils$OrcaPaymentPage.getString(jsonDict, "currencyCode", ""),
          total: ApplePayTypes$OrcaPaymentPage.getTotal(Utils$OrcaPaymentPage.getDictFromObj(jsonDict, "total")),
          merchantCapabilities: Utils$OrcaPaymentPage.getStrArray(jsonDict, "merchantCapabilities"),
          supportedNetworks: Utils$OrcaPaymentPage.getStrArray(jsonDict, "supportedNetworks")
        };
}

var thirdPartyApplePayConnectors = ["braintree"];

function handleApplePayBraintreePaymentSession(applePayPaymentRequest, applePayInstance, onError, onSuccess) {
  try {
    var transactionInfo = createApplePayTransactionInfo(applePayPaymentRequest);
    var paymentRequest = applePayInstance.createPaymentRequest(transactionInfo);
    var sessions = new ApplePaySession(14, paymentRequest);
    sessions.onvalidatemerchant = (function ($$event) {
        applePayInstance.performValidation({
              validationURL: $$event.validationURL,
              displayName: transactionInfo.total.label
            }, (function (err, merchantSession) {
                if (err == null) {
                  return sessions.completeMerchantValidation(merchantSession);
                } else {
                  onError(err);
                  return sessions.abort();
                }
              }));
      });
    sessions.onpaymentauthorized = (function ($$event) {
        applePayInstance.tokenize({
              token: $$event.payment.token,
              billingContact: null,
              shippingContact: null
            }, (function (err, payload) {
                var ssn = window.ApplePaySession;
                if (ssn == null) {
                  return onError("ApplePay session is null in onpaymentauthorized.");
                } else if (err == null) {
                  sessions.completePayment(ssn.STATUS_SUCCESS);
                  return onSuccess(payload.nonce);
                } else {
                  sessions.completePayment(ssn.STATUS_FAILURE);
                  return onError("ApplePay Tokenization Failed");
                }
              }));
      });
    sessions.oncancel = (function () {
        onError("Apple Pay Payment Cancelled.");
      });
    return sessions.begin();
  }
  catch (raw_err){
    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
    return onError(Utils$OrcaPaymentPage.formatException(err));
  }
}

function handleApplePayBraintreeClick(authorization, applePayPaymentRequest, selectorString, logger, $$event) {
  Utils$OrcaPaymentPage.messageParentWindow(undefined, [
        [
          "fullscreen",
          true
        ],
        [
          "param",
          "paymentloader"
        ],
        [
          "iframeId",
          selectorString
        ]
      ]);
  var onSuccess = function (token) {
    if (token === "") {
      Utils$OrcaPaymentPage.messageParentWindow(undefined, [
            [
              "fullscreen",
              false
            ],
            [
              "param",
              "paymentloader"
            ],
            [
              "iframeId",
              selectorString
            ]
          ]);
      Utils$OrcaPaymentPage.postFailedSubmitResponse("validation_error", "ApplePay Braintree nonce is empty");
      return logger.setLogError("ApplePay Braintree nonce is empty", "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
    } else {
      logger.setLogInfo("ApplePay Braintree payment Successfull", "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
      return Window$OrcaPaymentPage.sendPostMessage($$event.source, Object.fromEntries([
                      [
                        "applePayBraintreeSuccess",
                        true
                      ],
                      [
                        "token",
                        token
                      ]
                    ]));
    }
  };
  var onError = function (err) {
    logger.setLogError(JSON.stringify(err), "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
    Utils$OrcaPaymentPage.messageParentWindow(undefined, [
          [
            "fullscreen",
            false
          ],
          [
            "param",
            "paymentloader"
          ],
          [
            "iframeId",
            selectorString
          ]
        ]);
    Window$OrcaPaymentPage.sendPostMessage($$event.source, Object.fromEntries([[
                "showApplePayButton",
                true
              ]]));
  };
  try {
    braintree.client.create({
          authorization: authorization
        }, (function (err, clientInstance) {
            if (!(err == null)) {
              return onError(err);
            }
            try {
              logger.setLogInfo("Braintree ApplePay instance created successfully", "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
              braintree.applePay.create({
                    client: clientInstance
                  }, (function (err, applePayInstance) {
                      if (err == null) {
                        logger.setLogInfo("Braintree ApplePay payment session started", "APPLE_PAY_FLOW", undefined, undefined, undefined, undefined, "APPLE_PAY");
                        return handleApplePayBraintreePaymentSession(applePayPaymentRequest, applePayInstance, onError, onSuccess);
                      } else {
                        return onError(err);
                      }
                    }));
              return ;
            }
            catch (raw_err){
              var err$1 = Caml_js_exceptions.internalToOCamlException(raw_err);
              return onError(Utils$OrcaPaymentPage.formatException(err$1));
            }
          }));
    return ;
  }
  catch (raw_err){
    var err = Caml_js_exceptions.internalToOCamlException(raw_err);
    return onError(Utils$OrcaPaymentPage.formatException(err));
  }
}

export {
  processPayment ,
  getApplePayFromResponse ,
  startApplePaySession ,
  useHandleApplePayResponse ,
  handleApplePayButtonClicked ,
  useSubmitCallback ,
  createApplePayTransactionInfo ,
  thirdPartyApplePayConnectors ,
  handleApplePayBraintreePaymentSession ,
  handleApplePayBraintreeClick ,
}
/* react Not a pure module */
